import React, { Component } from 'react'
import CareersForm from './careers-form'

class Opportunities extends Component {

  state = {
    division: 'all',
    showForm: false,
    more: false,
    count: this.props.jobs?.length
  }

  toggleCategory = (category) => {
    const initialCount = this.props.jobs?.length
    let jobs = this.props.jobs?.filter((el) => el.division === category)
    this.setState({ 
      division: category,
      count: category === 'all' ? initialCount : jobs?.length,
      more: category === 'all' ? false : true,
    })
  }

  showForm = () => {
    this.setState({ showForm: true })
    setTimeout(() => {
      document && document.querySelector('.support__form').scrollIntoView({ 
        behavior: 'smooth' 
      });
    }, 100)
  }

  render() {

    let { division, showForm, count, more } = this.state

    let { title, divisions, jobs } = this.props

    return (
      <section className='our-partnerships-block support'>
        <div className='our-partnerships-block__inner'>
          <h3 className='support__title' dangerouslySetInnerHTML={{ __html: title }} />
          <div className='our-partnerships-block__content'>
            <div className='our-partnerships-block__menu'>
              { divisions &&
                <ul>
                  <li className={`${division === 'all' ? 'active' : ''}`}>
                    <button type='button' onClick={() => this.toggleCategory('all')}>All</button>
                  </li>
                  { divisions.map((el, i) => (
                    <li className={`${division === el.name ? 'active' : ''}`} key={i}>
                      <button type='button' onClick={() => this.toggleCategory(el.name)}>{el.title}</button>
                    </li>
                  ))}
                </ul>
              }
            </div>
            <div className='our-partnerships-block__components'>
              { jobs?.length > 0 && 
                <div className='community-efforts'>
                  <div className='community-efforts__content'>
                    { jobs &&
                      <div className={`community-efforts__items ${(more || division !== 'all') ? 'show-more' : ''}`}>
                        { count === 0 &&
                          <>
                            <p className='none'>If you are interested in possible future opportunities, please complete the form below.</p>
                            <p className='none'><button type='button' className='btn' onClick={() => this.showForm()}>Register your interest</button></p>
                          </>
                        }
                        { jobs?.map((el, i) => (
                          <div className={`community-efforts__item ${(division === el.division || division === 'all') ? 'active' : ''}`} key={i}>
                            <h4 className='heading' dangerouslySetInnerHTML={{ __html: el.title }} />
                            <div className='copy' dangerouslySetInnerHTML={{ __html: el.content }} />
                            { el.text &&
                              <button type='button' onClick={() => this.showForm()}>{ el.text }</button>
                            }
                          </div>
                        ))}
                      </div>
                    }
                    { count > 6 && !more &&
                      <button className='support__view-more btn' onClick={() => this.setState({ more: true })}>View More</button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
          <div className={`support__form ${showForm ? 'active' : ''}`}>
            <CareersForm jobs={jobs}  />
          </div>
        </div>
      </section>
    )
  }
}

export default Opportunities
